import request from "@/utils/oms-request";
import lms_request from "@/utils/request";
import download from "@/utils/oms-download";
import qs from "qs";
// pi管理 - 列表
export const getPiList = (params: any) =>
  request({
    url: "/proforma-invoices",
    method: "get",
    params,
  });
// 发货状态
export const getPiDeliveryStatus = () =>
  request({
    url: "/proforma-invoices/supplier-delivery-status",
    method: "get",
  });
// 客户交货状态
export const getPiCustomerShipmentStatus = () =>
  request({
    url: "/proforma-invoices/customer-shipment-status",
    method: "get",
  });
// 索赔状态
export const getPiClaimType = () =>
  request({
    url: "/claim_form/status",
    method: "get",
  });
//抵扣方式
export const getPiDeductionType = () =>
  request({
    url: "/claim_form/deduction-method",
    method: "get",
  });
// 修改备注
export const updatePiRemark = (id: any, data: any) =>
  request({
    url: `/proforma-invoices/${id}/remark`,
    method: "put",
    data,
  });
// 修改出货备注
export const updatePiShippingRemark = (id: any, remark: any) =>
  request({
    url: `/proforma-invoices/${id}/shipping-remark?remark=${remark}`,
    method: "put",
  });

// 作废
export const invalidPi = (id: any) =>
  request({
    url: `/proforma-invoices/${id}`,
    method: "put",
  });
// 撤销作废
export const uncancelPi = (id: any) =>
  request({
    url: `/proforma-invoices/${id}/uncancel`,
    method: "put",
  });
// 查询pi收款信息
export const getPiPaymentInfo = (id: any) =>
  request({
    url: `/proforma-invoices/${id}/payment-info`,
    method: "get",
  });
// 保存pi收款信息
export const savePiPaymentInfo = (id: any, data: any) =>
  request({
    url: `/proforma-invoices/${id}/payment-info`,
    method: "post",
    data,
  });
// 修改供应商
export const updatePiSupplier = (data: any) =>
  request({
    url: `/proforma-invoices/supplier`,
    method: "put",
    data,
  });
// 修改折扣和利润率
export const updatePIDiscountAndProfit = (data: any) =>
  request({
    url: `/proforma-invoices/discount`,
    method: "put",
    data,
  });
// 修改接单数量
export const updatePiShipmentQuantity = (data: any) =>
  request({
    url: `/proforma-invoices/shipment-quantity`,
    method: "put",
    data,
  });
// 导出包装资料
export const downloadPiPackageInfo = (params: any) =>
  download({
    responseType: "blob",
    url: `/proforma-invoices/download/package-info`,
    method: "get",
    params,
  });

// 查找组合单位
export const getPiCombinedUnit = (id: any) =>
  request({
    url: `/proforma-invoices/${id}/combined-unit`,
    method: "get",
  });
// 更新组合单位
export const putPiCombinedUnit = (id: any, data: any) =>
  request({
    url: `/proforma-invoices/${id}/combined-unit`,
    method: "put",
    data,
  });
// 批量维护订单拆分
export const updatePiPurchaseOrderGroup = (data: any) =>
  request({
    url: `/proforma-invoices/purchase-order-group`,
    method: "put",
    data,
  });
// 维护PO号码
export const updatePiPurchaseOrder = (id: any, data: any) =>
  request({
    url: `/proforma-invoices/${id}/purchase-order`,
    method: "put",
    data,
  });
// 修改下单数量
export const updatePiDeliveryQuantity = (data: any) =>
  request({
    url: `/proforma-invoices/delivery-quantity`,
    method: "put",
    data,
  });
// pi详情下载
export const downloadPiDetail = (id: any,accountType:string,infoIds:string[] = []) =>
  download({
    responseType: "blob",
    url: `/proforma-invoices/download`,
    method: "post",
    data:{
      id,
      accountType,
      infoIds
    }
  });
// 销售订单模板下载
export const downloadPiTemplate = (params: any) =>
  download({
    responseType: "blob",
    url: `/proforma-invoices/download/template`,
    method: "get",
    params,
  });
// pi详情上传维护
export const uploadPiDetail = (id: any, data: FormData) =>
  request({
    headers: { "Content-Type": "multipart/form-data" },
    url: `/proforma-invoices/${id}/upload`,
    method: "post",
    data,
  });
// pi订单详情
export const getPiDetail = (id: any, params: any) =>
  request({
    url: `/proforma-invoices/${id}/details`,
    method: "get",
    params,
  });
// pi订单详情-删除
export const deletePiDetail = (id: any) =>
  request({
    url: `/proforma-invoices/info/${id}`,
    method: "delete",
  });
// 交易类型-所有状态
export const getTradingTermsTypes = () =>
  request({
    url: "/proforma-invoices/trading-terms-types",
    method: "get",
  });
// 结算方式-所有状态
export const getSettlementTypes = () =>
  request({
    url: "/proforma-invoices/settlement-types",
    method: "get",
  });
// 付款方式-所有状态
export const getPaymentTypes = () =>
  request({
    url: "/proforma-invoices/payment-types",
    method: "get",
  });
// 获取客户收汇单
export const getContainerLoadLists = (params: any) =>
  request({
    url: "/proforma-invoices/container-load-lists",
    method: "get",
    params,
  });

// 确认下单
export const confirmOrder = (id: any,infoIds:any[]) =>
  request({
      url: `/proforma-invoices/${id}/order`,
      method: "post",
      data: {
          infoIds: infoIds
      }
  });
// 下单管理列表
export const getPurchaseOrderList = (id: any, params: any) =>
  request({
    url: `/proforma-invoices/${id}/purchase-order`,
    method: "get",
    params,
  });
// 查询供应商某个品名的中英文单位
export const getSupplierProduct = (supplierId: any, params: any) =>
  request({
    url: `/proforma-invoices/${supplierId}/supplier-product`,
    method: "get",
    params,
  });
// pi详情复制
export const copyPiDetail = (id: any, infoId: any) =>
  request({
    url: `/proforma-invoices/${id}/info/${infoId}/copy`,
    method: "put",
  });
// PI订单详情-页面头部信息查询
export const getPiInfo = (id: any) =>
  request({
    url: `/proforma-invoices/${id}/pi-info`,
    method: "get",
  });
// 批量指定唛头
export const putShippingMarks = (data: any) =>
  request({
    url: `/purchase-order/shipping-marks`,
    method: "put",
    data,
  });
// 获取pi唛头
export const getShippingMarks = (params: any) =>
  request({
    url: `/purchase-order/shipping-marks`,
    method: "get",
    params,
  });
// 作废
export const invalidPurchaseOrder = (id: any) =>
  request({
    url: `/purchase-order/${id}/invalid`,
    method: "put",
  });
// 删除唛头
export const deleteShippingMarks = (id: any) =>
  request({
    url: `/purchase-order/${id}/shipping-marks`,
    method: "delete",
  });
// 批量指定备注
export const putRemark = (data: any) =>
  request({
    url: `purchase-order/remark`,
    method: "put",
    data,
  });
// 头部
export const getDetailHeader = (id: any) =>
  request({
    url: `/purchase-order/${id}/detail-header`,
    method: "get",
  });
// 壳体包装资料列表
export const getShellPackages = (params: any) =>
  request({
    url: `/purchase-order/customer/shell-packages`,
    method: "get",
    params,
  });
// 匹配壳体包装资料
export const matchingShellPackages = (params: any) =>
  request({
    url: `/purchase-order/brand`,
    method: "get",
    params,
  });
// 查看订单详情
export const getPurchaseOrderDetail = (id: any, params: any) =>
  request({
    url: `/purchase-order/${id}/infos`,
    method: "get",
    params,
  });
// 客人库存
export const getCustomerInventory = (id: any, params: any) =>
  request({
    url: `/customer-inventory/proforma-invoices/${id}`,
    method: "get",
    params,
  });
//  查看所有号码
export const getCustomerInventoryModel = (params: any) =>
  request({
    url: `/customer-inventory/search/model?${params}`,
    method: "get",
  });
// 匹配库存
export const matchingInventory = (id: any) =>
  request({
    url: `/customer-inventory/matching-inventory/${id}`,
    method: "put",
  });
// 保存库存
export const saveInventory = (data: any) =>
  request({
    url: `/customer-inventory/save-inventory`,
    method: "put",
    data,
  });
// 查看PI型号已经使用的库存以及可用的库存
export const getExcessiveInventory = (id: any) =>
  request({
    url: `/customer-inventory/proforma-invoices-infos/${id}/excessive-inventory`,
    method: "get",
  });
// /customer-inventory/save-inventory
export const putSaveInventory = (data) =>
  request({
    url: `/customer-inventory/save-inventory`,
    method: "put",
    data,
  });

// 查看pi收款信息
export const getPaymentInfo = (id: any) =>
  request({
    url: `/proforma-invoices/${id}/payment-info`,
    method: "get",
  });
// 保存pi收款信息
export const savePaymentInfo = (id: any, data: any) =>
  request({
    url: `/proforma-invoices/${id}/payment-info`,
    method: "put",
    data,
  });
// 文件管理
export const getAppendix = (id: any, params: any) =>
  request({
    url: `/purchase-order/${id}/appendix`,
    method: "get",
    params,
  });
// 文件管理-替换
export const changeUpload = (id: any, data: any) =>
  request({
    url: `/proforma-invoices/${id}/upload-info`,
    method: "put",
    data,
  });
// 文件管理-删除
export const deleteInfo = (params: any) =>
  request({
    url: `/proforma-invoices/upload-info?${params}`,
    method: "delete",
  });
// 文件管理-上传
export const uploadInfoFile = (data: any) =>
  request({
    url: `/proforma-invoices/upload-info`,
    method: "post",
    data,
  });

// /proforma-invoices/{id}/upload-info
// 文件管理-替换
export const uploadInfoReFile = (id, data: any) =>
  request({
    url: `/proforma-invoices/${id}/upload-info`,
    method: "put",
    data,
  });

// 查看包装和配件
export const getPackingAndAccessories = (infoId: any) =>
  request({
    url: `/proforma-invoices/${infoId}/packing-and-accessories`,
    method: "get",
  });
// 编辑包装和配件
export const updatePackingAndAccessories = (infoId: any, data: any) =>
  request({
    url: `/proforma-invoices/${infoId}/packing-and-accessories`,
    method: "put",
    data,
  });
// 包装配件类型
export const getPackingAndAccessoriesType = () =>
  request({
    url: `/proforma-invoices/packing-and-accessories`,
    method: "get",
  });
// 新建包装配件 /proforma-invoices/{id}/packing-and-accessories
export const createPackingAndAccessories = (id: any, data: any) =>
  request({
    url: `/proforma-invoices/${id}/packing-and-accessories`,
    method: "post",
    data,
  });
// 详情记录类型
export const getProformaInvoiceTypes = () =>
  request({
    url: `/proforma-invoices/proforma-invoice/types`,
    method: "get",
  });
//查看超欠发列表 /proforma-invoices/{id}/overdue
export const getOverdue = (id: any) =>
  request({
    url: `/proforma-invoices/${id}/overdue`,
    method: "get",
  });
// 出货备注
export const putShippingRemark = (infoId: any, data: any) =>
  request({
    url: `/proforma-invoices/${infoId}/shipping-remark`,
    method: "put",
    data,
  });
//下载销售订单模版
export const downloadTemplate = (params) =>
  download({
    responseType: "blob",
    url: `/proforma-invoices/download/package-info`,
    method: "get",
    params,
  });
// 获取异常发货状态
export const getAbnormalDeliveryState = () =>
  request({
    url: `/abnormal-delivery/state`,
    method: "get",
  });
//异常交货列表
export const getAbnormalDelivery = (id: any, params: any) =>
  request({
    url: `/abnormal-delivery/proforma-invoices/${id}`,
    method: "get",
    params,
  });
// 管理异常数量
export const abnormalDeliveryPoInfos = (id: any) =>
  request({
    url: `/abnormal-delivery/po-infos/${id}/manage`,
    method: "get",
  });
// 维护PO号码
export const putPoNumber = (data: any) =>
  request({
    url: `/proforma-invoices/po`,
    method: "put",
    data,
  });

export const abnormalDeliveryDownload = (params) =>
  download({
    responseType: "blob",
    url: `/abnormal-delivery/download`,
    method: "get",
    params,
  });
//超发
export const abnormalDeliveryOverdelivery = (id: any, markQty: any) =>
  request({
    url: `/abnormal-delivery/po-infos/${id}/overdelivery?markQty=${markQty}`,
    method: "put",
  });
// 欠发
export const abnormalDeliveryUnderdelivery = (id: any, data: any) =>
  request({
    url: `/abnormal-delivery/po-infos/${id}/underdelivery`,
    method: "put",
    data,
  });
// 更新采购订单
export const updatePurchaseOrder = (id: any) =>
  request({
    url: `/proforma-invoices/${id}/update-po`,
    method: "put",
  });
//异常交货-使用客人库存列表
export const abnormalDeliveryInventoryList = (id: any) =>
  request({
    url: `/abnormal-delivery/po-infos/${id}/inventory-list`,
    method: "get",
  });

// 修改折后采购单价
export const updatepurchaseUnitPrice = (id: any, params) =>
  request({
    url: `/proforma-invoices/${id}/post-discount-purchase-unit-price`,
    method: "put",
    params,
  });

// /proforma-invoices/{id}/batch-number
// 维护生产批次号
// 修改折后采购单价
export const updateBatchNumber = (id: any, params) =>
  request({
    url: `/proforma-invoices/${id}/batch-number`,
    method: "put",
    params,
  });
// /proforma-invoices/{id}/update-po
// 更新PI及采购订单
export const updatePIAndCaiGou = (id: any, infoIds: any) =>
    request({
        url: `/proforma-invoices/${id}/update-po`,
        method: "put",
        params: {
            infoIds: infoIds
        },
    });

// 导出额外信息
export const downloadOtherInfo = (params: any) =>
  download({
    responseType: "blob",
    url: `/proforma-invoices/download/other-info`,
    method: "get",
    params,
  });
// 销售订单-修改品牌
export const updateBrand = (id: any, brandId:string) =>
  request({
    url: `/proforma-invoices/${id}/brand`,
    method: "put",
    params:{
      brandId:brandId
    },
  });

// /proforma-invoices/remittance-advice
export const getRemittanceAdvice = (params) =>
  request({
    url: `/proforma-invoices/remittance-advice`,
    method: "get",
    params,
  });

// 更新采购订单关联
// /proforma-invoices/{id}/relation
export const updateOrderRelation = (id) =>
  request({
    url: `/proforma-invoices/${id}/relation`,
    method: "put",
  });

// /proforma-invoices/purchase-order/{id}
export const deleteFile = (id: any) =>
  request({
    url: `/proforma-invoices/purchase-order/${id}`,
    method: "delete",
  });

// /proforma-invoices/po-code/{keyword}
// 模糊查询销售订单
export const searchPiCode = (keyword) =>
  request({
    url: `/proforma-invoices/po-code/${keyword}/list`,
    method: "get",
  });

// /proforma-invoices/{id}/pi-remark
export const PIMangentRemark = (id, data) =>
  request({
    url: `/proforma-invoices/${id}/pi-remark`,
    method: "put",
    data
  });
  // /customs-packing/search-inventory
  export const getSearchInventory = (poInfoId: string) =>
  lms_request({
    url: `/customs-packing/mix-inventory?poInfoId=${poInfoId}`,
    method: "post",
  });

/**
 * PI型号正常使用库存
 * @param data
 */
export const putSaveChooseInventory = (piInfoId:string, data:any) =>
  request({
    url: `/customer-inventory/save-choose-inventory?piInfoId=${piInfoId}`,
    method: "put",
    data
  });

  // /abnormal-delivery/po-infos/{id}/over-delivery-list
  export const getOverDeliveryList = (id) =>
    request({
      url: `/abnormal-delivery/po-infos/${id}/over-delivery-list`,
      method: "get",
    });


  // /proforma-invoices/{id}/update-po
  export const getUpdatePo = (id,selectCancelDesc:boolean) =>
    request({
      url: `/proforma-invoices/${id}/update-po`,
      method: "get",
      params:{
        selectCancelDesc:selectCancelDesc
      }
    });

   // 删除组合单位
  export const deleteCombinedUnit = (id) =>
    request({
      url: `/proforma-invoices/info/${id}/delete-combined-unit`,
      method: "delete",
    });

  // 获取批量指定唛头表格数据
  export const getAssignMarkInfo = (id: string) =>
      request({
          url: `/proforma-invoices/${id}/purchase-orders/assign-mark-info`,
          method: "get",
      });

    // 更新PO品牌
  export const updatePoBrand = (id: string,brandId:string) =>
      request({
          url: `/purchase-order/${id}/brand`,
          method: "PUT",
        data:{
            brandId:brandId,
        }
      });

  // 导出贴标资料
export const downloadLabelInfo = (id:string) =>
  download({
    responseType: "blob",
    url: `/proforma-invoices/${id}/label-info`,
    method: "get"
  });

// 导出备份的额外信息
export const downloadBackupOtherInfo = (params: any) =>
  download({
    responseType: "blob",
    url: `/proforma-invoices/download/backup-other-info`,
    method: "get",
    params,
  });
    // 指定样品
  export const specifySample = (id:string, type:string) =>
    request({
      url: `/proforma-invoices/info/${id}/specify-sample`,
      method: "PUT",
      data:{
        type:type
      }
    });
  // 取消指定样品
  export const cancelSpecifySample = (id:string) =>
    request({
      url: `/proforma-invoices/info/${id}/cancel-specify-sample`,
      method: "PUT",
    });

  // 贴标资料所有类型
export const labelInfoTypes = () =>
 request({
    url: `/proforma-invoices/label-info_types`,
    method: "get",
  });

export const packageProviders = () =>
    request({
        url: `/proforma-invoices/package-provider`,
        method: "get",
    })

// 导出PI的所有采购订单贴标资料
export const downloadPiAllPoLabelInfo = (id:string,changeState:boolean) =>
  download({
    responseType: "blob",
    url: `/proforma-invoices/${id}/all-po-label_info`,
    method: "get",
    params:{
      changeState:changeState
    },
  });
//下载异常处理后的信息
export const downloadExcDeliveryInfo = (id: any, params: any) =>
    download({
        responseType: "blob",
        url: `/abnormal-delivery/download/${id}`,
        method: "get",
        params,
    });

// 模糊查询销售用户有权限的订单号
export const searchByCodeKeyword = (params) =>
    request({
        url: `/proforma-invoices/by-code-keyword`,
        method: "get",
        params
    })
/**
 * 在线更新产品单位。
 * @param infoId
 * @param unit
 */
export const updateProductUnit = (infoId: string, unit: string) =>
    request({
        url: `/proforma-invoices/info/${infoId}/unit`,
        method: "put",
        params: {
            newChineseUnit: unit
        }
    })
/**
 * 批量删除PI信息。
 * @param id
 * @param ids
 */
export const batchDeleteInfo = (id: string, ids: string[]) =>
    request({
        url: `/proforma-invoices/info/${id}/batch`,
        method: "delete",
        data: ids
    })

/**
 * 根据供应商、产品类型、采购订单组查询可用的采购订单
 * @param id
 * @param supplierId
 * @param productType
 * @param purchaseOrderGroup
 */
export const findAvailPurchaseOrder = (id:string, supplierId:string,productType:string) =>
    request({
        url: `/proforma-invoices/${id}/info/available-po`,
        method: "get",
        params:{
            supplierId: supplierId,
            type: productType
        }
    });
/**
 * 指定采购订单动作以及采购订单
 * @param id
 * @param supplierId
 * @param productType
 * @param purchaseOrderGroup
 */
export const specifyPoActionAndPo = (id:string, actionDescOrPoNumber:string) =>
    request({
        url: `/proforma-invoices/info/${id}/specify-po-action-and-po`,
        method: "put",
        data:{
            actionDescOrPoNumber: actionDescOrPoNumber
        }
    });

export const queryCustomerByShipmentTrack = (params) =>
    request({
        url: `/proforma-invoices/shipment-track/customers`,
        method: "get",
        params
    });

// 某个客人的pi的交货期追踪
export const queryShipmentTrack = (params) =>
    request({
        url: `/proforma-invoices/shipment-track`,
        method: "get",
        params,
        paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" })
    });

export const queryPIShipmentStatusCountOfCustomer = (params) =>
    request({
        url: `/proforma-invoices/shipment-status-count`,
        method: "get",
        params
    });

// PI 下采购订单交期跟踪
export const queryPoDeliveryTrack = (params) =>
    request({
        url: `/proforma-invoices/po-delivery-track`,
        method: "get",
        params,
    });

// PI修改交货期页面的查询
export const detailQueryDeliveryDate = (id: string) =>
    request({
        url: `/proforma-invoices/${id}/delivery-date`,
        method: "get",
    });

// PI详情修改交货期
export const updatePiDeliveryDate = (id: string, params) =>
    request({
        url: `/proforma-invoices/${id}/delivery-date`,
        method: "put",
        params,
    });

// PI/询价单根据产品号码查询历史价格
export const queryHistoryPriceInPiForModel = (params) =>
    request({
        url: `/proforma-invoices/history-price`,
        method: "get",
        params,
    });

// PI发货记录
export const piInfoShipmentRecords = (id) =>
    request({
        url: `/proforma-invoices/infos/${id}/shipment-records`,
        method: "get",
    });

// 超欠发订单数量（侧栏角标）
export const getOverOrOweCount = () =>
    request({
        url: `/abnormal-delivery/pending-processing/count`,
        method: "get",
    });

// 超欠发列表
export const queryPendingProcessing = (params) =>
    request({
        url: `/abnormal-delivery/pending-processing`,
        method: "get",
        params,
    });

